import { createLoggerFunc } from '@updater-core/lib/logger';
import { ENVIRONMENT } from '@updater-core/lib/environment';

export const createLogger = (...args) =>
  createLoggerFunc(
    ENVIRONMENT.debug?.tvInternetApp,
    '[DEBUG][HOME SERVICES APP]',
    'color: #36980f'
  )(...args);
